import { render } from "./board_audit_packs.html?vue&type=template&id=01b6d256&external"
import script from "./board_audit_packs.js?vue&type=script&lang=js&external"
export * from "./board_audit_packs.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__